window.vf.enterpriseFlyout = (function () {
    'use strict';
    // TODO README
    var config = {
        'containerSelector': '.mod-ep-flyout',
        'triggerSelector': '.mod-ep-flyout__tab',
        'contentSelector': '.mod-ep-flyout__content',
        'targetDataAttribut': 'target',
        'callbackDataAttribut': 'onchoose',
        'activeClass': 'mod-ep-flyout_active'

    };

    var callbacks = {'init': []};

    function trackTabClick($tab, proactive) {
        // Nur ein mal tracken
        if (true !== $tab.data('tracked')) {
            // Tracking Code
            //console.log('TRACK ME!', $tab);
            var title = $tab.data('tracking-title');
            if (!proactive) {
                $tab.data('tracked', true);
            }

            if (_ddq) {
                var tabTitles = [];
                $(config.triggerSelector).each(function (index, elem) {
                    var currentTitle = $(elem).data('tracking-title');
                    tabTitles.push(currentTitle || '');
                });

                _ddq.push(['flyout', {
                    'action': (proactive) ? 'show' : 'click',
                    'tool': title,
                    'variant': (proactive) ? 'proactive' : 'reactive',
                    'tools': tabTitles
                }]);

            }

        }
    }

    function ensureTriggerElement(triggerElement) {
        var isTrigger = $(triggerElement).is(config.triggerSelector);
        var $realTrigger = $(triggerElement).parents(config.triggerSelector);
        var isChildOfTrigger = 0 < $realTrigger.length;
        if (!isTrigger && !isChildOfTrigger) {
            console.warn('ensureTriggerElement needs a trigger Element (of Child of Trigger Element) as Parameter: ' + config.triggerSelector);
            return null;
        }

        var $element = (isChildOfTrigger) ? $realTrigger : $(triggerElement);
        return $element;
    }

    function setContainerActive(active) {
        if (active) {
            $(config.containerSelector).addClass(config.activeClass);
        } else {
            $(config.containerSelector).removeClass(config.activeClass);
        }
    }

    function activateTabElement($element) {
        $(config.triggerSelector, config.containerSelector).removeClass(config.activeClass);
        $element.addClass(config.activeClass);
    }

    function activateContentElement($element) {
        $(config.contentSelector, config.containerSelector).removeClass(config.activeClass);
        $element.parent().find(config.contentSelector).addClass(config.activeClass);
    }

    function execCallbacks(callbackName) {
        var cbs = callbacks[callbackName];
        if (callbackName && cbs) {
            for (var index = 0; index < cbs.length; index++) {
                var cb = cbs[index];
                cb();
            }
        }
    }

    function execCallbacksForElement($triggerElement) {
        var callbackName = $triggerElement.data(config.callbackDataAttribut);
        execCallbacks(callbackName);
    }

    function deactivateAll() {
        $(config.contentSelector, config.containerSelector).removeClass(config.activeClass);
        $(config.triggerSelector, config.containerSelector).removeClass(config.activeClass);
        setContainerActive(false);
    }


    function openFlyout(triggerElement, forceOpen) {
        var $element = ensureTriggerElement(triggerElement);
        if ($element && !$element.is('.' + config.activeClass)) {
            activateTabElement($element);
            setContainerActive(true);
            activateContentElement($element);

            trackTabClick($element, forceOpen);

            execCallbacksForElement($element);
        } else if ($element && $element.is('.' + config.activeClass)) {
            // toggle function
            deactivateAll();
        }

    }

    function on(callbackEvent, callback) {
        if (!callbacks[callbackEvent]) {
            callbacks[callbackEvent] = [];
        }
        callbacks[callbackEvent].push(callback);
    }


    function clickedTriggerOrContent(targetElement) {
        return $(targetElement).is(config.containerSelector) || 0 < $(targetElement).parents(config.containerSelector).length;
    }

    function setEvents() {
        var evtlOpenFlyout = function (evt) {
            return openFlyout(evt.target);
        };
        $(config.triggerSelector, config.containerSelector).off('click', evtlOpenFlyout).on('click', evtlOpenFlyout);

        var evtClickedTriggerOrContent = function (evt) {
            if (!clickedTriggerOrContent(evt.target)) {
                deactivateAll();
            }
        };
        $(document).off('click', evtClickedTriggerOrContent).on('click', evtClickedTriggerOrContent);
    }

    function addNumberOfTabs() {
        var numberOfTabs = $(config.triggerSelector).length;
        $(config.containerSelector).addClass(config.containerSelector.substr(1) + '_' + numberOfTabs);
    }

    function initGuckGuck() {
        window.vf.enterpriseFlyoutGuckGuck.init();
        window.vf.enterpriseFlyoutGuckGuck.startGuckGuck();
    }

    function shouldRun() {
        return $(config.containerSelector).is(':visible');
    }

    function init(conf) {
        config = Object.assign({}, config, conf);
        if (!shouldRun) {
            return false;
        }
        setEvents();
        addNumberOfTabs();
        initGuckGuck();
        execCallbacks('init');

        try {
            if ('unedfined' === typeof window.vf.enterpriseIframeModal) {
                return true;
            }
            window.vf.enterpriseIframeModal.init();
        } catch (error) {
            console.warn(error);
        }

        return true;
    }

    function conditionconfig() {
        return {
            'forLayout': 'desktop',
            'appendTo': '#content'
        };
    }


    return {
        'openFlyout': openFlyout,
        'on': on,
        'init': init,
        'closeFlyout': deactivateAll,
        'trackOpen': trackTabClick,
        'getConfig': function () {
            return config;
        },
        'conditionconfig': conditionconfig
    };


})();

window.vf.enterpriseFlyoutGuckGuck = (function () {
    'use strict';

    var config = {
        'cookieprefix': 'ep_flyout_',
        'containerSelector': '.mod-ep-flyout',
        'openGuckGuckForSeconds': 3,
        'flyout': window.vf.enterpriseFlyout
    };

    var timer = null;

    function getWaitTime() {
        var $element = $(config.containerSelector);
        return parseFloat($element.data('opentime') || config.openGuckGuckForSeconds, 10);
    }


    function setCookie(id) {
        window.sessionStorage.setItem(config.cookieprefix + id, true);
    }

    function getCookieIdFromElement($element) {
        return $element.data('id');
    }

    function guckGuckAlreadyDone(id) {
        return !!window.sessionStorage.getItem(config.cookieprefix + id);
    }

    function clearEventsWhileGuckGuck() {
        var flyoutConfig = config.flyout.getConfig();
        $(flyoutConfig.contentSelector, flyoutConfig.containerSelector).off('mouseover', cancelGuckGuckClose);
        $(flyoutConfig.triggerSelector, flyoutConfig.containerSelector).off('click', cancelGuckGuckClose);
    }

    function cancelGuckGuckClose() {
        var flyoutConfig = config.flyout.getConfig();
        var $firstTrigger = $(flyoutConfig.triggerSelector, flyoutConfig.containerSelector).eq(0);
        window.clearTimeout(timer);
        clearEventsWhileGuckGuck();
        config.flyout.trackOpen($firstTrigger);
    }


    function setEventsWhileGuckGuck() {
        var flyoutConfig = config.flyout.getConfig();
        $(flyoutConfig.contentSelector, flyoutConfig.containerSelector).on('mouseover', cancelGuckGuckClose);
        $(flyoutConfig.triggerSelector, flyoutConfig.containerSelector).on('click', cancelGuckGuckClose);
    }


    function startGuckGuck() {
        var $element = $(config.containerSelector);
        var id = getCookieIdFromElement($element);
        if (!guckGuckAlreadyDone(id)) {
            var flyoutConfig = config.flyout.getConfig();
            var $firstTrigger = $(flyoutConfig.triggerSelector, flyoutConfig.containerSelector).eq(0);
            config.flyout.openFlyout($firstTrigger, true);
            setCookie(id);
            timer = window.setTimeout(function () {
                clearEventsWhileGuckGuck();
                config.flyout.closeFlyout();
            }, getWaitTime() * 1000);
            setEventsWhileGuckGuck();
        }
    }


    function init(conf) {
        config = Object.assign({}, config, conf);
    }

    return {
        'init': init,
        'startGuckGuck': startGuckGuck
    };

})();
